var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
export class BrowserExtraContent {
    parent;
    get browserRuntime() {
        return this.parent;
    }
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    isBottomRightMessageShowing = false;
    triggerBottomRightNotification() {
        if (this.browserRuntime.browserDevice.isTabletOrSmartphone)
            return;
        if (document.getElementsByTagName('article').length === 0)
            return;
        if (this.isBottomRightMessageShowing)
            return;
        this.isBottomRightMessageShowing = true;
        setTimeout(() => (this.isBottomRightMessageShowing = false), 5000);
        this.showBottomRightNotification();
    }
    async showBottomRightNotification() {
        await this.browserRuntime.app.notification.info({
            message: 'Wir haben Extra-Lernstoff für dich:',
            duration: 5,
            onClose: () => {
                this.isBottomRightMessageShowing = false;
            },
            description: React.createElement(ExtraContent, { app: this.browserRuntime.app }),
            placement: 'bottomRight',
        });
    }
}
__decorate([
    action.bound
], BrowserExtraContent.prototype, "triggerBottomRightNotification", null);
__decorate([
    action.bound
], BrowserExtraContent.prototype, "showBottomRightNotification", null);
let ExtraContent = class ExtraContent extends React.PureComponent {
    render() {
        const { app } = this.props;
        return (React.createElement("button", { onClick: action(async () => {
                await this.props.app.notification.destroy();
                this.showBackToQuiz();
                window.scrollTo({
                    top: window.innerHeight,
                    behavior: 'smooth',
                });
            }) }, "Schritt-f\u00FCr-Schritt-Anleitung"));
    }
    showBackToQuiz = async () => {
        await this.props.app.notification.open({
            message: '',
            duration: 15,
            description: (React.createElement("button", { onClick: action(() => {
                    this.props.app.notification.destroy();
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });
                }) }, "Zur\u00FCck zum Quiz")),
            placement: 'bottomRight',
        });
    };
};
ExtraContent = __decorate([
    observer
], ExtraContent);
